import React from 'react'
import { gql } from '@apollo/client'
import { initializeApollo } from 'gql/client'
import { PAGINA } from 'utils/queries'
import ContattaciTemplate from 'components/templates/ContattaciTemplate/ContattaciTemplate'
import { NextWrapper } from 'data-fetching-wrapper'

const ContattaciPage = ({ pagina }) => <ContattaciTemplate pagina={pagina} />

export const getStaticProps = NextWrapper.getStaticProps(async ({ locale }) => {
  const client = initializeApollo(null, null, null, locale)

  const {
    data: { pagina },
  } = await client.query({
    query: gql`
      ${PAGINA.replace('__chiave__', 'contattaci')}
    `,
  })

  if (!pagina) {
    return {
      notFound: true,
    }
  }

  return {
    props: { pagina }, // will be passed to the page component as props
    revalidate: 60 * 10, // In seconds
  }
}, '/contattaci/')

export default ContattaciPage
